import QRCode from "react-qr-code";
import { useRef } from "react";
import * as htmlToImage from "html-to-image";
import { Download } from "lucide-react";
import { Scan_URL } from "../../../Process";

export const ShopQR = ({ shop }) => {
  const qrRef = useRef();

  if (!shop) return null;

  const mobile = shop?.ShopUserDetail?.[0]?.ShopUserMobileNo?.toString() || "";

  // ✅ ONLY REQUIRED DATA
  const payload = {
    ShopDetailID: shop.ShopDetailID,
    ShopName: shop.ShopName,
    mobile: mobile,
  };

  // const encoded = btoa(JSON.stringify(payload));
  // const scanUrl = `${Scan_URL}scan?data=${encoded}`;

  const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
  const scanUrl = `${Scan_URL}scan?data=${encoded}`;

  const handleDownload = async () => {
    if (!qrRef.current) return;

    try {
      const dataUrl = await htmlToImage.toPng(qrRef.current, {
        pixelRatio: 3,
        backgroundColor: "#ffffff",
        filter: (node) => {
          // 👇 Ignore elements with this attribute
          return !node.dataset?.html2canvasIgnore;
        },
      });

      const link = document.createElement("a");
      link.download = `shop-${shop.ShopDetailID}.png`;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("QR download failed", err);
    }
  };

  return (
    <div ref={qrRef} className="relative bg-white rounded-lg shadow-md border border-gray-100 px-3 py-3 w-[170px] flex flex-col items-center">
      {/* Download Icon */}
      <button
        onClick={handleDownload}
        data-html2canvas-ignore="true"
        className="absolute top-1.5 right-1.5 bg-blue-600 hover:bg-blue-700 text-white p-1 rounded-full shadow transition"
      >
        <Download size={12} />
      </button>

      {/* Shop Name */}
      <h3 className="text-[11px] font-semibold text-gray-800 text-center mb-1 truncate w-full">{shop.ShopName}</h3>

      {/* Divider */}
      <div className="w-6 h-[2px] bg-blue-600 rounded-full mb-1"></div>

      {/* Mobile */}
      <p className="text-[9px] text-gray-500 mb-2 tracking-wide">{mobile}</p>

      {/* QR */}
      <div className="bg-gray-50 p-2 rounded-md shadow-inner">
        <QRCode value={scanUrl} size={90} level="H" />
      </div>

      {/* Footer */}
      <p className="text-[8px] text-gray-400 mt-2 text-center">Scan to submit daily close</p>
    </div>
  );
};
